import React from 'react';
import { CheckCircle2, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface UploadedFileProps {
  fileName: string;
  isEncrypting: boolean;
  onEncrypt: () => void;
  buttonText: string;
}

export const UploadedFile = ({ fileName, isEncrypting, onEncrypt, buttonText }: UploadedFileProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
      <div className="flex items-center space-x-3">
        <CheckCircle2 className="w-6 h-6 text-green-500" />
        <p className="text-lg font-medium text-gray-700">
          {fileName} uploaded successfully
        </p>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Shield className="w-5 h-5 text-primary" />
          <span className="text-sm text-gray-600">Ready for encryption</span>
        </div>
        <Button
          onClick={onEncrypt}
          disabled={isEncrypting}
          className="gap-2"
        >
          {isEncrypting ? (
            <>
              <div className="w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin" />
              {buttonText === "Decrypt File" ? "Decrypting..." : "Encrypting..."}
            </>
          ) : (
            <>
              <Shield className="w-4 h-4" />
              {buttonText}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};